export const scrollServiceDrawerToTop = headerElement => {
    const drawerPapers = document.querySelectorAll('.MuiDrawer-paper.custom-dialog-right');
    const drawerPaper = drawerPapers[drawerPapers.length - 1];
    if (!drawerPaper) return;

    drawerPaper.scrollTo({ top: 0 });
    drawerPaper.querySelector('.custom-dialog-right__inner')?.scrollTo({ top: 0 });

    const header = headerElement || drawerPaper.querySelector('.popup-wrapper-top');
    header?.scrollIntoView({ behavior: 'auto', block: 'start' });
};
